import React from "react";
import {
	Modal,
	Form,
	Accordion,
	Spinner,
	OverlayTrigger,
	Tooltip,
} from "react-bootstrap";

// Konfigurasi form fields untuk setiap domain TLD 
const domainConfigs = {
	'.co.id': {
		fields: [
			{
				id: 'coid-ktp',
				name: 'coid-ktp',
				label: 'KTP Republik Indonesia/Paspor milik penganggung jawab pendaftar',
				required: true
			},
			{
				id: 'coid-siup',
				name: 'coid-siup',
				label: 'SIUP/NIB/TDP/AKTA Surat Ijin yang setara/NPWP Perusahaan',
				required: true
			},
			{
				id: 'coid-cert-merk',
				name: 'coid-cert-merk',
				label: 'Sertifikat Merek',
				required: false,
				note: '(Jika Ada)'
			}
		],
		footer: 'Apabila Pendaftar adalah Instansi Penyelenggara Negara, maka pendaftaran Nama Domain mengikuti Ketetapan Menteri yang membidangi Komunikasi dan Informatika.'
	},
	'.ac.id': {
		fields: [
			{
				id: 'acid-ktp',
				name: 'acid-ktp',
				label: 'KTP Republik Indonesia/Paspor milik penganggung jawab pendaftar',
				required: true
			},
			{
				id: 'acid-sk',
				name: 'acid-sk',
				label: 'Akta Notaris atau Surat Keterangan dari Organisasi yang Bersangkutan',
				required: true
			},
			{
				id: 'acid-surat',
				name: 'acid-surat',
				label: 'Surat Permohonan Pendaftaran Domain dari Organisasi/Lembaga Terkait',
				required: false
			}
		],
		footer: 'Apabila KTP/Paspor yang dilampirkan adalah KTP Pimpinan Lembaga, maka Surat Kuasa dari Pimpinan Lembaga tidak diperlukan.',
		downloadTemplate: {
			text: 'Download Template Surat Permohonan & Surat Kuasa .ac.id',
			path: 'sknsp/Surat%20permohonan%20dan%20surat%20kuasa%20.ac.id.docx'
		}
	},
	'.or.id': {
		fields: [
			{
				id: 'orid-ktp',
				name: 'orid-ktp',
				label: 'KTP Republik Indonesia/Paspor milik penganggung jawab pendaftar',
				required: true
			},
			{
				id: 'orid-akta',
				name: 'orid-akta',
				label: 'Akta Notaris atau Surat Keterangan dari Organisasi yang Bersangkutan',
				required: true
			},
			{
				id: 'orid-surat',
				name: 'orid-surat',
				label: 'Surat Permohonan Pendaftaran Domain dari Organisasi/Lembaga Terkait',
				required: false
			}
		],
		downloadTemplate: {
			text: 'Download Template Surat Permohonan & Surat Kuasa .or.id',
			path: 'sknsp/Surat%20permohonan%20dan%20surat%20kuasa%20.or.id.docx'
		}
	},
	'.ponpes.id': {
		fields: [
			{
				id: 'ponpes-ktp',
				name: 'ponpes-ktp',
				label: 'KTP Republik Indonesia/Paspor milik penganggung jawab pendaftar',
				required: true
			},
			{
				id: 'ponpes-surat',
				name: 'ponpes-surat',
				label: 'Akta Notaris atau Surat Keterangan dari Organisasi yang Bersangkutan',
				required: true
			}
		],
		downloadTemplate: {
			text: 'Download Template Surat Keterangan .ponpes.id',
			path: 'sknsp/Surat%20permohonan%20.ponpes.id.docx'
		}
	},
	'.sch.id': {
		type: 'accordion',
		sections: [
			{
				title: 'Untuk Sekolah Resmi',
				eventKey: '0',
				onClick: 'formal',
				fields: [
					{
						id: 'schid-surat',
						name: 'schid-surat',
						label: 'Surat Keterangan Kepala Sekolah atau Kepala Lembaga',
						required: true
					},
					{
						id: 'schid-ktp',
						name: 'schid-ktp',
						label: 'KTP Republik Indonesia',
						required: true
					}
				]
			},
			{
				title: 'Untuk Pendidikan Non-Formal yang Diakui oleh SKPD',
				eventKey: '1',
				onClick: 'non-formal',
				fields: [
					{
						id: 'schid-sk-non',
						name: 'schid-sk-non',
						label: 'Surat Keterangan Kepala Sekolah atau Kepala Lembaga',
						required: true
					},
					{
						id: 'schid-ktp-non',
						name: 'schid-ktp-non',
						label: 'KTP Republik Indonesia',
						required: true
					}
				]
			}
		]
	},
	// '.web.id': {
	//   fields: [
	//     {
	//       id: 'webid-ktp',
	//       name: 'webid-ktp',
	//       label: 'KTP Republik Indonesia/Paspor milik penganggung jawab pendaftar',
	//       required: true
	//     }
	//   ]
	// }
};

const ModalAccordionByDomain = ({
	show,
	onHide,
	domain,
	tld,
	tldArr,
	syarat,
	handleFileChange,
	handlerSendDocument,
	handlerSkipAll,
	loading,
	disabledButton,
	setSekolah,
}) => {
	const renderFileInput = (name) => (
		<>
			<div className="d-flex">
				<Form.Control
					className="custom-file"
					type="file"
					name={name}
					onChange={handleFileChange}
				/>
				<Form.Label className="custom-button">
					Pilih Gambar
				</Form.Label>
			</div>
			<p className="text-secondary mt-2" style={{ fontSize: "12px" }}>
				<i>*File: Maks. 2MB, tipe yang diperbolehkan: PNG, JPG, JPEG, PDF.</i>
			</p>
		</>
	);

	const renderFormFields = (fields) => {
		return fields.map(field => (
			<div className="mb-3" key={field.id}>
				<Form.Group controlId={field.id} className="mb-3">
					<Form.Label>
						{field.label}{field.note ? ` ${field.note}` : ''}{field.required ? '*' : ''}
					</Form.Label>
					{renderFileInput(field.name)}
				</Form.Group>
			</div>
		));
	};

	const renderAccordionContent = (config) => (
		<>
			<h6 className="mb-3"> Pilih Untuk Sekolah Resmi atau Pendidikan Non-Formal di Bawah :</h6>
			<Accordion defaultActiveKey="0" flush>
				{config.sections.map(section => (
					<Accordion.Item
						key={section.eventKey}
						eventKey={section.eventKey}
						onClick={() => setSekolah(section.onClick)}
					>
						<Accordion.Header>{section.title}</Accordion.Header>
						<Accordion.Body>
							<form>
								{renderFormFields(section.fields)}
							</form>
						</Accordion.Body>
					</Accordion.Item>
				))}
			</Accordion>
		</>
	);

	const renderStandardForm = (config) => (
		<div className="form">
			{renderFormFields(config.fields)}
			{config.footer && <p className="mt-2">{config.footer}</p>}
			{config.downloadTemplate && (
				<p className="mt-2">
					<a href={`${process.env.REACT_APP_QWORDS_API}${config.downloadTemplate.path}`}>
						{config.downloadTemplate.text}
					</a>
				</p>
			)}
		</div>
	);

	const renderModalContent = () => {
		const config = domainConfigs[tld];

		if (!config) {
			return (
				<div className="form">
					<div className="mb-3">
						<Form.Group controlId="international-document" className="mb-3">
							<Form.Label>{syarat}*</Form.Label>
							{renderFileInput("international-document")}
						</Form.Group>
					</div>
				</div>
			);
		}

		return config.type === 'accordion'
			? renderAccordionContent(config)
			: renderStandardForm(config);
	};

	return (
		<Modal show={show} onHide={onHide} backdrop="static" centered>
			<Modal.Header closeButton>
				<Modal.Title>Domain Bersyarat</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<h3 className="mb-4">{domain}</h3>
				<form>
					{renderModalContent()}
					<div className="row gap-3 mt-5">
						<div className="col-12">
							<button
								className="btn btn-modal-login"
								disabled={disabledButton}
								onClick={handlerSendDocument}
								type="submit"
							>
								{loading ? <Spinner animation="border" size="sm" /> : "Simpan"}
							</button>
						</div>
					</div>
				</form>
				<div className="row mt-3">
					<div className="col-12">
						<button
							className="btn btn-modal-outline-daftar w-100"
							onClick={onHide}
						>
							Lengkapi Nanti
						</button>
					</div>
					{tldArr.length > 1 && (
						<div className="col-12 mt-3 text-center">
							<button
								className="border-0 text-primary bg-transparent"
								onClick={() => {
									handlerSkipAll();
									onHide();
								}}
								style={{ cursor: "pointer" }}
							>
								Lewati Semuanya
							</button>
							<OverlayTrigger
								placement="right"
								overlay={
									<Tooltip>
										Lewati semua {tldArr.length} persyaratan domain
									</Tooltip>
								}
							>
								<span
									className="d-inline-block px-2 py-0 ms-1 fw-bold text-white bg-primary"
									style={{
										cursor: "pointer",
										borderRadius: "50%",
										fontSize: "12px",
									}}
								>
									!
								</span>
							</OverlayTrigger>
						</div>
					)}
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default ModalAccordionByDomain;
